// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Default Font Size is 14px on the HTML page, use the below scale to adjust font sizes.

8pt = 0.571rem
10pt = 0.714rem
12pt = 0.857rem
14pt = 1rem (base font size)
18pt = 1.285rem
20pt = 1.428rem
22pt = 1.571rem
24pt = 1.714rem
28pt = 2rem
30pt = 2.142rem
32pt = 2.285rem
*/
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezClocker Supported Media Screen Sizes
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/*------------------------------------------------------
| @Media Small Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Regular Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Tablets
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Laptops
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Desktops
--------------------------------------------------------*/
/* Use http://paletton.com to generate pallets */
.ezBackgroundImage {
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.07) 50%, transparent 50%), linear-gradient(90deg, rgba(255, 255, 255, 0.13) 50%, transparent 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.17) 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.19) 50%);
  background-size: 13px, 29px, 37px, 53px;
}

.ez-float-left {
  float: left;
}

.ez-float-right {
  float: left;
}

.ez-bring-to-front {
  z-index: 9999;
}

.ez-hidden {
  display: none;
}

.ez-topish {
  margin-top: 25%;
}

.ez-full-width {
  width: 100%;
}

input {
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1rem;
  padding: 4px;
  display: block;
  background-color: #ffffff;
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
  margin: 0;
}
input:focus {
  border-color: #ff9900;
  outline-color: #ff9900;
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgba(255, 153, 0, 0.3);
}

label.ez-input-label {
  display: block;
  background-color: transparent;
  color: #000000;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 0.857rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-bottom: 2px;
  margin-top: 4px;
}

label.ez-marketing-input-label {
  display: block;
  background-color: transparent;
  color: #000000;
  font-family: "Roboto", Verdana, sans-serif;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-bottom: 4px;
  margin-top: 8px;
}

div.ez-input-box {
  text-align: left;
  background-color: transparent;
  padding: 20px;
}

div.ez-center-input-button-box {
  text-align: center;
  background-color: transparent;
  padding: 20px;
  padding-top: 10px;
}

a.ez-input-link {
  background-color: transparent;
  font-size: 0.857rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-bottom: 2px;
  margin-top: 4px;
}

a.ez-marketing-input-link {
  background-color: transparent;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-bottom: 2px;
  margin-top: 4px;
}

input[type=password].ez-hidden-input-password {
  display: none;
  font-family: monospace;
}

input.marketing {
  font-size: 1.285rem;
}

input[type=password] {
  font-family: monospace;
}

input[type=date] {
  font-family: monospace;
}

input[type=datetime] {
  font-family: monospace;
}

input[type=datetime-local] {
  font-family: monospace;
}

input[type=file] {
  font-family: monospace;
}

input[type=month] {
  font-family: monospace;
}

input[type=number] {
  font-family: monospace;
}

input[type=tel] {
  font-family: monospace;
}

input[type=time].ezTime {
  font-family: monospace;
}

input[type=week].ezWeek {
  font-family: monospace;
}

input[type=radio] {
  padding-bottom: 4px;
}

input[type=radio]:focus {
  padding-bottom: 4px;
}

input[type=reset].ez-reset-major {
  background-color: #ff9900;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=reset].ez-reset-major:hover {
  background-color: #ffcc66;
}

input[type=reset].ez-reset-major:active {
  background-color: #ff9933;
}

input[type=reset].ez-reset-action-button {
  background-color: #8df13c;
  border-radius: 2px;
  border: 1px solid #439400;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=reset].ez-reset-action-button:hover {
  background-color: #caff9e;
}

input[type=reset].ez-reset-action-button:active {
  color: #caff9e;
  background-color: #439400;
}

input[type=reset].ez-reset-edit {
  background-color: #f0f0f0;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: normal;
  padding: 4px;
  text-decoration: none;
}

input[type=reset].ez-reset-edit:hover {
  background-color: #edf6ff;
}

input[type=reset].ez-reset-edit:active {
  background-color: #6d6e70;
}

input[type=search] {
  font-size: 1rem;
  padding: 4px;
  background-color: #ffffff;
  border-color: #000000;
  border-style: solid;
  border-width: 1px;
}

input[type=submit].ez-input-submit-major {
  background-color: #ff9900;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=submit].ez-input-submit-major:hover {
  background-color: #ffcc66;
}

input[type=submit].ez-input-submit-major:active {
  background-color: #ff9933;
}

input[type=submit].ezSubmitActionButton {
  background-color: #8df13c;
  border-radius: 2px;
  border: 1px solid #439400;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
}

input[type=submit].ezSubmitActionButton:hover {
  background-color: #caff9e;
}

input[type=submit].ezSubmitActionButton:active {
  color: #caff9e;
  background-color: #439400;
}

input[type=submit] {
  background-color: #f0f0f0;
  border-radius: 2px;
  border: 1px solid #000000;
  display: inline-block;
  cursor: pointer;
  color: #000000;
  font-family: Verdana;
  font-size: 12px;
  font-weight: normal;
  padding: 4px;
  text-decoration: none;
}

input[type=submit]:hover {
  background-color: #edf6ff;
}

input[type=submit]:active {
  background-color: #6d6e70;
}

/* Other Input Related Styles */
.ezInputLabel {
  font-size: 14;
  padding-top: 4px;
  padding-bottom: 2px;
  /* color: var(--ezClockerBlack); */
  color: #000000;
}

.editorLabel {
  font-size: 14;
  color: #000000;
  padding-top: 4px;
  padding-bottom: 2px;
}

.oversizedEditor {
  font-size: 16pt;
  font-style: bold;
}

.fullWidthEditor {
  width: 100%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

option {
  font-size: 1rem;
  padding: 4px;
  background-color: #ffffff;
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

option:focus {
  border-color: #ff9900;
  outline-color: #ff9900;
  outline-style: solid;
  outline-width: 1px;
  /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */
  box-shadow: 0 0 2px 1px rgba(255, 153, 0, 0.3);
}

select {
  font-size: 1rem;
  padding: 4px;
  background-color: #ffffff;
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select:focus {
  border-color: #ff9900;
  outline-color: #ff9900;
  outline-style: solid;
  outline-width: 1px;
  /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */
  box-shadow: 0 0 2px 1px rgba(255, 153, 0, 0.3);
}

/* Specific Select Input Styles */
select.ez-reports-override {
  font-size: 1rem;
  padding: 4px;
  background-color: #ffffff;
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.ez-reports-override:focus {
  border-color: #ff9900;
  outline-color: #ff9900;
  outline-style: solid;
  outline-width: 1px;
  /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */
  box-shadow: 0 0 2px 1px rgba(255, 153, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./ezlibrary/welcome/css/ez-responsive.scss","webpack://./ezlibrary/welcome/css/ez-core.scss","webpack://./ezlibrary/welcome/css/ez-inputs.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;CAAA;AAyDA;;yDAAA;AAaA;;yDAAA;AAOA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;ACnGA,gDAAA;AA0LA;EACI,gTAAA;EAIA,uCAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,eAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AApDA;EACI,0CAAA;EACA,eFSyB;EERzB,YAAA;EACA,cAAA;EACA,yBAAA;EACA,qBDPY;ECQZ,mBAAA;EACA,iBAAA;EACA,SAAA;AAuDJ;AAtDI;EACI,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8CAAA;AAwDR;;AApDA;EACI,cAAA;EACA,6BAAA;EACA,cDlBa;ECmBb,0CAAA;EACA,mBFdwB;EEexB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AAuDJ;;AApDA;EACI,cAAA;EACA,6BAAA;EACA,cD/Ba;ECgCb,0CAAA;EACA,eF1ByB;EE2BzB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AAuDJ;;AApDA;EACI,gBAAA;EACA,6BAAA;EACA,aAAA;AAuDJ;;AApDA;EACI,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;AAuDJ;;AApDA;EACI,6BAAA;EACA,mBFlDwB;EEmDxB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AAuDJ;;AApDA;EACI,6BAAA;EACA,eF3DyB;EE4DzB,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AAuDJ;;AApDA;EACI,aAAA;EACA,sBAAA;AAuDJ;;AAnDA;EACI,mBFzEyB;AE+H7B;;AAlDA;EACI,sBAAA;AAqDJ;;AAjDA;EACI,sBAAA;AAoDJ;;AAhDA;EACI,sBAAA;AAmDJ;;AA/CA;EACI,sBAAA;AAkDJ;;AA9CA;EACI,sBAAA;AAiDJ;;AA7CA;EACI,sBAAA;AAgDJ;;AA5CA;EACI,sBAAA;AA+CJ;;AA3CA;EACI,sBAAA;AA8CJ;;AA1CA;EACI,sBAAA;AA6CJ;;AAzCA;EACI,sBAAA;AA4CJ;;AAxCA;EACI,mBAAA;AA2CJ;;AAzCA;EACI,mBAAA;AA4CJ;;AAxCA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AA2CJ;;AAzCA;EACI,yBAAA;AA4CJ;;AA1CA;EACI,yBAAA;AA6CJ;;AAzCA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AA4CJ;;AA1CA;EACI,yBAAA;AA6CJ;;AA3CA;EACI,cAAA;EACA,yBAAA;AA8CJ;;AA1CA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AA6CJ;;AA3CA;EACI,yBAAA;AA8CJ;;AA5CA;EACI,yBDhNY;AC+PhB;;AA3CA;EACI,eFzMyB;EE0MzB,YAAA;EACA,yBDjNa;ECkNb,qBAAA;EACA,mBAAA;EACA,iBAAA;AA8CJ;;AA1CA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AA6CJ;;AA3CA;EACI,yBAAA;AA8CJ;;AA5CA;EACI,yBAAA;AA+CJ;;AA5CA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AA+CJ;;AA5CA;EACI,yBAAA;AA+CJ;;AA5CA;EACI,cAAA;EACA,yBAAA;AA+CJ;;AA3CA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AA8CJ;;AA5CA;EACI,yBAAA;AA+CJ;;AA7CA;EACI,yBD3RY;AC2UhB;;AA5CA,+BAAA;AAGA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,cAAA;AA6CJ;;AA1CA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA6CJ;;AA1CA;EACI,eAAA;EACA,gBAAA;AA6CJ;;AA1CA;EACI,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AA6CJ;;AAxCA;EACI,eFpTyB;EEqTzB,YAAA;EACA,yBD5Ta;EC6Tb,qBDnUY;ECoUZ,mBAAA;EACA,iBAAA;EACA,qBAAA;AA2CJ;;AAzCA;EACI,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uDAAA;EACA,8CAAA;AA4CJ;;AAvCA;EACI,eFxUyB;EEyUzB,YAAA;EACA,yBDhVa;ECiVb,qBDvVY;ECwVZ,mBAAA;EACA,iBAAA;EACA,qBAAA;AA0CJ;;AAxCA;EACI,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uDAAA;EACA,8CAAA;AA2CJ;;AAxCA,iCAAA;AAGA;EACI,eF7VyB;EE8VzB,YAAA;EACA,yBDrWa;ECsWb,qBD5WY;EC6WZ,mBAAA;EACA,iBAAA;EACA,qBAAA;AAyCJ;;AAvCA;EACI,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uDAAA;EACA,8CAAA;AA0CJ","sourcesContent":["/*\r\nDefault Font Size is 14px on the HTML page, use the below scale to adjust font sizes.\r\n\r\n8pt = 0.571rem\r\n10pt = 0.714rem\r\n12pt = 0.857rem\r\n14pt = 1rem (base font size)\r\n18pt = 1.285rem\r\n20pt = 1.428rem\r\n22pt = 1.571rem\r\n24pt = 1.714rem\r\n28pt = 2rem\r\n30pt = 2.142rem\r\n32pt = 2.285rem\r\n*/\r\n\r\n// Responseive Font Sizes\r\n$ezResponsivePicoFontSize: 0.517rem;\r\n$ezResponsiveMicroFontSize: 0.714rem;\r\n$ezResponsiveSmallFontSize: 0.857rem;\r\n$ezResponsiveNormalFontSize: 1rem;\r\n$ezResponsiveMediumFontSize: 1.285rem;\r\n$ezResponsiveLargeFontSize: 1.428rem;\r\n$ezResponsiveExtraLargeFontSize: 1.571rem;\r\n$ezResponsiveHugeFontSize: 1.714rem;\r\n$ezResponsiveExtraHugeFontSize: 2rem;\r\n$ezResponsiveMassiveFontSize: 2.142rem;\r\n$ezResponsiveExtraMassiveFontSize: 2.285rem;\r\n\r\n// Responseive Font Sizes\r\n$ezResponsiveMarketingPicoFontSize: $ezResponsiveMicroFontSize;\r\n$ezResponsiveMarketingMicroFontSize: $ezResponsiveSmallFontSize;\r\n$ezResponsiveMarketingSmallFontSize: $ezResponsiveNormalFontSize;\r\n$ezResponsiveMarketingNormalFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveMarketingMediumFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveMarketingLargeFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveMarketingExtraLargeFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingHugeFontSize: $ezResponsiveExtraHugeFontSize;\r\n$ezResponsiveMarketingExtraHugeFontSize: $ezResponsiveMassiveFontSize;\r\n$ezResponsiveMarketingMassiveFontSize: $ezResponsiveExtraMassiveFontSize;\r\n$ezResponsiveMarketingSuperFontSize: 2.428rem;\r\n\r\n// Responsive Normal Header and Title Font Sizes\r\n$ezResponsiveHeaderFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveSubHeaderFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveTitleFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveLabelFontSize: $ezResponsiveMediumFontSize;\r\n\r\n// Responsive Marketing Header and Title Font Sizes\r\n$ezResponsiveMarketingHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingSubHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingTitleFontSize: $ezResponsiveHugeFontSize;\r\n\r\n$ezRespnsiveLogoWidth: 100%;\r\n$ezResponseLogoHeight: auto;\r\n\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezClocker Supported Media Screen Sizes\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\n$ezSmallMobileMinWidth: 240;\r\n$ezSmallMobileMaxWidth: 319;\r\n$ezMobileMinWidth: 320px;\r\n$ezMobileMaxWidth: 480px;\r\n$ezTabletMinWidth: 481px;\r\n$ezTabletMaxWidth: 1023px;\r\n$ezLaptopMinWidth: 1024px;\r\n$ezLaptopMaxWidth: 1919px;\r\n$ezDesktopMinWidth: 1920px;\r\n\r\n/*------------------------------------------------------\r\n| @Media Small Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (max-width: $ezSmallMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Regular Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezMobileMinWidth) and\r\n    (max-width: $ezMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Tablets\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezTabletMinWidth) and\r\n    (max-width: $ezTabletMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Laptops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezLaptopMinWidth) and\r\n    (max-width: $ezLaptopMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Desktops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezDesktopMinWidth) {\r\n}\r\n\r\n","@use 'ez-responsive.scss';\r\n\r\n/* Use http://paletton.com to generate pallets */\r\n\r\n// Primary ezClocker Colors\r\n$ezClockerOrange: #ff9900;\r\n$ezClockerNavy: #0f4777; // rgb(15,71,119)\r\n$ezClockerYellow: #ffc500;\r\n$ezClockerGray: #6d6e70; // rgb(109,110,112)\r\n$ezClockerAquaGray: #6a737d;\r\n$ezClockerSilver: #e0e0e0; // rgb(224,224,224)\r\n$ezClockerActionGreen: #8EF13C;\r\n$ezClockerAlertRed: #FF0700;\r\n$ezClockerBlack: #000000;\r\n$ezClockerWhite: #ffffff;\r\n\r\n// Specail Use Colors\r\n$ezClockerSmokeyTooth: #f7f4ec;\r\n$ezClockerBackground: #E1E1E1;\r\n\r\n// Rarely Used Legacy Colors\r\n$ezClockerAqua: #316dac;\r\n$ezClockerBlue: #2419b2;\r\n$ezClockerBabyBlue: #7CD0FD;\r\n\r\n// ezClocker Smokey Tooth Shades (#f7f4ec)\r\n$ezSmokeyTooth: $ezClockerSmokeyTooth;\r\n$ezSmokeyToothLight: $ezClockerWhite;\r\n$ezSmokeyToothHover: #FFFEFC;\r\n$ezDarkSmokeyTooth: #D0CBBC;\r\n$ezBorderSmokeyTooth: #AFA68E;\r\n\r\n// ezClocker Orange Shades (#ff9900)\r\n$ezOrange: #ff9900;\r\n$ezLightOrange: #FFC164;\r\n$ezHoverOrange: #FFB039;\r\n$ezDarkOrange: #C67700;\r\n$ezBorderOrange: #9B5D00;\r\n\r\n// ezClocker Navy Shades (#0f4777)\r\n$ezNavy: var($ezClockerNavy);\r\n$ezNavyContainerTextColor: var($ezClockerWhite);\r\n$ezLightNavy: #3B6F9B;\r\n$ezHoverNavy: #1D5D93;\r\n$ezDarkNavy: #063861;\r\n$ezBorderNavy: #032746;\r\n$ezAqua: var($ezClockerAqua);\r\n$ezLightAqua: #7AA7D5;\r\n$ezHoverAqua: #4F85BE;\r\n$ezDarkAqua: #1058A3;\r\n$ezBorderAqua: #0A417A;\r\n$ezNavyContainerDisabledTextColor: var($ezBorderNavy);\r\n$ezNavyAlpha: rgba(15, 71, 119, 0.8);\r\n\r\n// ezClocker yellow shades (#ffc500)\r\n$ezYellow: var($ezClockerYellow);\r\n$ezYelloContainerText: #000000;\r\n$ezLightYellow: #FFDB64;\r\n$ezHoverYellow: #FFD239;\r\n$ezDarkYellow: #C69800;\r\n$ezBorderYellow: #9B7800;\r\n\r\n// ezClocker Gray shades (#6d6e70)\r\n$ezGrayAlpha: rgba(109, 110, 112, 0.9);\r\n$ezGray: $ezClockerGray;\r\n$ezGrayContainerText: $ezClockerWhite;\r\n$ezLightGray: #B2B3B4;\r\n$ezHoverGray: #8A8B8D;\r\n$ezDarkGray: #515255;\r\n$ezBorderGray: #323437;\r\n\r\n// ezClocker Aqua Gray Shared\r\n$ezAquaGray: $ezClockerGray;\r\n$ezAquaGrayContainerText: $ezClockerBackground;\r\n$ezLightAquaGray: #B7BABE;\r\n$ezHoverAquaGray: #898F96;\r\n$ezDarkAquaGray: #505B67;\r\n$ezBorderAquaGray: #374350;\r\n\r\n// ezClocker Blue Shades (#2419b2)\r\n$ezBlue: var($ezClockerGray);\r\n$ezLightBlue: #665EC6;\r\n$ezHoverBlue: #463DB7;\r\n$ezDarkBlue: #1B128A;\r\n$ezBorderBlue: #120B6D;\r\n\r\n// ezClocker silver shares (#e0e0e0)\r\n$ezSilverAlpha: rgba(224, 224, 224, 0.8);\r\n$ezSilver: var($ezClockerSilver);\r\n$ezLightSilver: #f0f0f0;\r\n$ezDarkSilver: #B3B3B3;\r\n$ezBorderSilver: #878686;\r\n\r\n// ezClocker ActionGreen shaes (#8EF13C)\r\n$ezActionGreen: var($ezClockerActionGreen);\r\n$ezLightActionGreen: #C0F991;\r\n$ezHoverActionGreen: #A5F562;\r\n$ezDarkGreen: #77ED16;\r\n$ezBorderGreen: #65DF00;\r\n\r\n// ezClocker AlertRed shades (#FF0700)\r\n$ezAlertText: var($ezClockerWhite);\r\n$ezAlertRed: var($ezClockerAlertRed);\r\n$ezLightAlertRed: #FF6864;\r\n$ezHoverAlertRed: #FF3E39;\r\n$ezDarkAlertRed: #C60500;\r\n$ezBorderAlertRed: #9B0400;\r\n\r\n// ezClocker BabyBlue (#7CD0FD) Shades\r\n$ezBabyBlue: var($ezClockerBabyBlue);\r\n$ezLightBabyBlue: #E8F7FF;\r\n$ezHoverBabyBlue: #A9E0FE;\r\n$ezDarkBabyBlue: #54C0FA;\r\n$ezBorderBabyBlue: #2CACF1;\r\n\r\n// Black Shades\r\n$ezBlack: #000000;\r\n$ezLightBlack: #7F7E7E;\r\n$ezHoverBlack: #464646;\r\n\r\n// White Shades\r\n$ezWhite: var($ezClockerWhite);\r\n$ezDarkWhite: #CECECE;\r\n$ezBorderWhite: #A2A0A0;\r\n\r\n// Background Colors\r\n$ezBackgroundColor: $ezClockerBackground;\r\n$ezAlphaBackgroundColor: rgba(225, 225, 225, .3);\r\n$ezAlphaDarkBackgroundColor: rgba(225, 225, 225, .8);\r\n$ezGrayAlphaBackgroundColor: rgba(128, 128, 128, .4);\r\n$ezDarkBackgroundColor: #B4B4B4;\r\n$ezDarkAlphaBackgroundColor: rgba(180, 180, 180, .3);\r\n\r\n$ezBorderBackgrounColor: #888787;\r\n$ezBorderAlphaBackgroundColor: rgba(136, 135, 135, .3);\r\n\r\n$ezBackgroundImageGradientAlphaWhite1: rgba(255, 255, 255, .07);\r\n$ezBackgroundImageGradientAlphaWhite2: rgba(255, 255, 255, .13);\r\n$ezBackgroundImageGradientAlphaWhite3: rgba(255, 255, 255, .17);\r\n$ezBackgroundImageGradientAlphaWhite4: rgba(255, 255, 255, .19);\r\n\r\n// Text Colors\r\n$ezTextColor: $ezClockerBlack;\r\n$ezLightTextColor: $ezClockerGray;\r\n$ezTitleTextColor: $ezClockerNavy;\r\n$ezHeaderTextColor: $ezClockerBlack;\r\n$ezSubHeaderTextColor: $ezClockerNavy;\r\n\r\n// Font Family\r\n$ezFontFamilyRoboto: 'Roboto';\r\n$ezFontFamilyVerdana: Verdana;\r\n$ezFontFamilySansSerif: sans-serif;\r\n\r\n// Normal Font Sizes\r\n$ezFontSize: 14pt;\r\n\r\n$ezPicoFontSize: 8pt;\r\n$ezMicroFontSize: 10pt;\r\n$ezSmallFontSize: 12pt;\r\n$ezNormalFontSize: $ezFontSize;\r\n$ezMediumFontSize: 18pt;\r\n$ezLargeFontSize: 20pt;\r\n$ezExtraLargeFontSize: 22pt;\r\n\r\n// Normal Header and Title Font Sizes\r\n$ezHeaderFontSize: $ezExtraLargeFontSize;\r\n$ezSubHeaderFontSize: $ezMediumFontSize;\r\n$ezTitleFontSize: $ezLargeFontSize;\r\n\r\n// Marketing Font Sizes\r\n$ezMarketingPicoFontSize: $ezMicroFontSize;\r\n$ezMarketingMicroFontSize: $ezSmallFontSize;\r\n$ezMarketingSmallFontSize: $ezNormalFontSize;\r\n$ezMarketingNormalFontSize: $ezMediumFontSize;\r\n$ezMarketingMediumFontSize: $ezLargeFontSize;\r\n$esMarketingLargeFontSize: $ezExtraLargeFontSize;\r\n$ezMarketingExtraLargeFontSize: 24pt;\r\n\r\n// Marketing Header and Title Font Sizes\r\n$ezMarketingHeaderFontSize: $ezMarketingExtraLargeFontSize;\r\n$ezMarketingSubHeaderFontSize: $ezMarketingMediumFontSize;\r\n$ezMarketingTitleFontSize: $esMarketingLargeFontSize;\r\n\r\n// margins and padding/\r\n$ezDefaultMarginSize: 0;\r\n$ezDefaultPaddingSize: 0;\r\n\r\n// Background Images\r\n.ezBackgroundImage {\r\n    background-image: linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite1 50%, transparent 50%),\r\n    linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite2 50%, transparent 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite3 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite4 50%);\r\n    background-size: 13px, 29px, 37px, 53px;\r\n}\r\n\r\n.ez-float-left {\r\n    float: left\r\n}\r\n\r\n.ez-float-right {\r\n    float: left\r\n}\r\n\r\n.ez-bring-to-front {\r\n    z-index: 9999;\r\n}\r\n\r\n.ez-hidden {\r\n    display: none;\r\n}\r\n\r\n.ez-topish {\r\n    margin-top: 25%;\r\n}\r\n\r\n.ez-full-width {\r\n    width: 100%;\r\n}\r\n","@use 'ez-core';\r\n@use \"ez-responsive\";\r\n\r\n$ezInputFontSize: ez-responsive.$ezResponsiveNormalFontSize;\r\n$ezMarketingInputFontSize: ez-responsive.$ezResponsiveMarketingNormalFontSize;\r\n$ezInputLabelFontSize: ez-responsive.$ezResponsiveSmallFontSize;\r\n$ezMarketingInputLabelFontSize: ez-responsive.$ezResponsiveMarketingSmallFontSize;\r\n\r\n// Generic Input Styles\r\ninput {\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: $ezInputFontSize;\r\n    padding: 4px;\r\n    display: block;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    border-color: ez-core.$ezClockerGray;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 0;\r\n    &:focus {\r\n        border-color: #ff9900;\r\n        outline-color: #ff9900;\r\n        outline-style: solid;\r\n        outline-width: 1px;\r\n        box-shadow: 0 0 2px 1px rgba(255, 153, 0, .3);\r\n    }\r\n}\r\n\r\nlabel.ez-input-label {\r\n    display: block;\r\n    background-color: transparent;\r\n    color: ez-core.$ezClockerBlack;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: $ezInputLabelFontSize;\r\n    font-weight: bold;\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: 2px;\r\n    margin-top: 4px;\r\n}\r\n\r\nlabel.ez-marketing-input-label {\r\n    display: block;\r\n    background-color: transparent;\r\n    color: ez-core.$ezClockerBlack;\r\n    font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    font-size: $ezMarketingInputLabelFontSize;\r\n    font-weight: bold;\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: 4px;\r\n    margin-top: 8px;\r\n}\r\n\r\ndiv.ez-input-box {\r\n    text-align: left;\r\n    background-color: transparent;\r\n    padding: 20px;\r\n}\r\n\r\ndiv.ez-center-input-button-box {\r\n    text-align: center;\r\n    background-color: transparent;\r\n    padding: 20px;\r\n    padding-top: 10px;\r\n}\r\n\r\na.ez-input-link {\r\n    background-color: transparent;\r\n    font-size: $ezInputLabelFontSize;\r\n    font-weight: bold;\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: 2px;\r\n    margin-top: 4px;\r\n}\r\n\r\na.ez-marketing-input-link {\r\n    background-color: transparent;\r\n    font-size: $ezMarketingInputLabelFontSize;\r\n    font-weight: bold;\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: 2px;\r\n    margin-top: 4px;\r\n}\r\n\r\ninput[type=\"password\"].ez-hidden-input-password {\r\n    display: none;\r\n    font-family: monospace;\r\n}\r\n\r\n// Marketing Inputs\r\ninput.marketing {\r\n    font-size: $ezMarketingInputFontSize;\r\n}\r\n\r\n// Password Inputs\r\ninput[type=\"password\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Date Inputs\r\ninput[type=\"date\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Date Time Inputs\r\ninput[type=\"datetime\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Date Time Local Inputs\r\ninput[type=\"datetime-local\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// File Inputs\r\ninput[type=\"file\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Month Inputs\r\ninput[type=\"month\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Number Inputs\r\ninput[type=\"number\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Telephone Input\r\ninput[type=\"tel\"] {\r\n    font-family: monospace;\r\n}\r\n\r\n// Time input\r\ninput[type=\"time\"].ezTime {\r\n    font-family: monospace;\r\n}\r\n\r\n// Week Input\r\ninput[type=\"week\"].ezWeek {\r\n    font-family: monospace;\r\n}\r\n\r\n// Radio Inputs\r\ninput[type=\"radio\"] {\r\n    padding-bottom: 4px;\r\n}\r\ninput[type=\"radio\"]:focus {\r\n    padding-bottom: 4px;\r\n}\r\n\r\n// ez-reset-major input button\r\ninput[type=\"reset\"].ez-reset-major {\r\n    background-color: #ff9900;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"reset\"].ez-reset-major:hover {\r\n    background-color: #ffcc66;\r\n}\r\ninput[type=\"reset\"].ez-reset-major:active {\r\n    background-color: #ff9933;\r\n}\r\n\r\n// ez-reset-action input button\r\ninput[type=\"reset\"].ez-reset-action-button {\r\n    background-color: #8df13c;\r\n    border-radius: 2px;\r\n    border: 1px solid #439400;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"reset\"].ez-reset-action-button:hover {\r\n    background-color: #caff9e;\r\n}\r\ninput[type=\"reset\"].ez-reset-action-button:active {\r\n    color: #caff9e;\r\n    background-color: #439400;\r\n}\r\n\r\n// ez-reset-edit input button\r\ninput[type=\"reset\"].ez-reset-edit {\r\n    background-color: #f0f0f0;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    padding: 4px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"reset\"].ez-reset-edit:hover {\r\n    background-color: #edf6ff;\r\n}\r\ninput[type=\"reset\"].ez-reset-edit:active {\r\n    background-color: ez-core.$ezClockerGray;\r\n}\r\n\r\n// Search input button\r\ninput[type=\"search\"] {\r\n    font-size: $ezInputFontSize;\r\n    padding: 4px;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    border-color: #000000;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n// ez-input-submit-major button\r\ninput[type=\"submit\"].ez-input-submit-major {\r\n    background-color: #ff9900;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"submit\"].ez-input-submit-major:hover {\r\n    background-color: #ffcc66;\r\n}\r\ninput[type=\"submit\"].ez-input-submit-major:active {\r\n    background-color: #ff9933;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton {\r\n    background-color: #8df13c;\r\n    border-radius: 2px;\r\n    border: 1px solid #439400;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    padding: 6px 24px;\r\n    text-decoration: none;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton:hover {\r\n    background-color: #caff9e;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton:active {\r\n    color: #caff9e;\r\n    background-color: #439400;\r\n}\r\n\r\n// Submit input button\r\ninput[type=\"submit\"] {\r\n    background-color: #f0f0f0;\r\n    border-radius: 2px;\r\n    border: 1px solid #000000;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000000;\r\n    font-family: Verdana;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    padding: 4px;\r\n    text-decoration: none;\r\n}\r\ninput[type=\"submit\"]:hover {\r\n    background-color: #edf6ff;\r\n}\r\ninput[type=\"submit\"]:active {\r\n    background-color: ez-core.$ezClockerGray;\r\n}\r\n\r\n\r\n/* Other Input Related Styles */\r\n\r\n// Other Input Related Styles\r\n.ezInputLabel {\r\n    font-size: 14;\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    /* color: var(--ezClockerBlack); */\r\n    color: #000000;\r\n}\r\n\r\n.editorLabel {\r\n    font-size: 14;\r\n    color: #000000;\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n}\r\n\r\n.oversizedEditor {\r\n    font-size: 16pt;\r\n    font-style: bold;\r\n}\r\n\r\n.fullWidthEditor {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n}\r\n\r\n\r\n// Generic option styles\r\noption {\r\n    font-size: $ezInputFontSize;\r\n    padding: 4px;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    border-color: ez-core.$ezClockerGray;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\noption:focus {\r\n    border-color: #ff9900;\r\n    outline-color: #ff9900;\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */\r\n    box-shadow: 0 0 2px 1px rgba(255, 153, 0, .3);\r\n}\r\n\r\n\r\n// Genercic Select Input Styles\r\nselect {\r\n    font-size: $ezInputFontSize;\r\n    padding: 4px;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    border-color: ez-core.$ezClockerGray;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\nselect:focus {\r\n    border-color: #ff9900;\r\n    outline-color: #ff9900;\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */\r\n    box-shadow: 0 0 2px 1px rgba(255, 153, 0, .3);\r\n}\r\n\r\n/* Specific Select Input Styles */\r\n\r\n// ez-reports-override select box\r\nselect.ez-reports-override {\r\n    font-size: $ezInputFontSize;\r\n    padding: 4px;\r\n    background-color: ez-core.$ezClockerWhite;\r\n    border-color: ez-core.$ezClockerGray;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\nselect.ez-reports-override:focus {\r\n    border-color: #ff9900;\r\n    outline-color: #ff9900;\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */\r\n    box-shadow: 0 0 2px 1px rgba(255, 153, 0, .3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
